import React from "react";
import loadingImg from '../../assets/brain_logo.svg'
import './Loading.css'
import { Spin } from 'antd'
import { Loading3QuartersOutlined } from '@ant-design/icons'

const Loading = () => {
  const antIcon = (
    <Loading3QuartersOutlined
      style={{
        fontSize: 100,
        color: 'white ',
      }}
      spin
    />
  )

  return (
    <div className="loading-image-container">
      {/* <img className="heartbeat-loader" src={loadingImg} alt="" /> */}
      <Spin indicator={antIcon} />
    </div>
  )
}

export default Loading;
